module.exports = __webpack_public_path__ + "assets/fonts/Gotham-XLightItalic.4ce64337.otf";